export class ListBillingTransactionHistoryRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "billingProvider",
            "baseName": "billingProvider",
            "type": "BillingProvider",
            "format": ""
        },
        {
            "name": "timeFrame",
            "baseName": "timeFrame",
            "type": "TimeFrame",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListBillingTransactionHistoryRequest.attributeTypeMap;
    }
    constructor() {
    }
}
